<template>
    <div v-if="show"
         id="modal-email-phone"
         class="modal d-block"
         tabindex="-1"
         role="dialog"
         data-backdrop="static"
    >
        <div class="modal-dialog modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm Your Contact Details</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" id="phone_email_info">
                    <div class="mb-4">
                        Please confirm your contact information in the display below.
                        If the data is correct, just check the box to confirm your information is accurate and
                        click "Save and Confirm" to confirm your information.
                        If you need to make updates, click to visit your profile.
                    </div>
                    <div class="alert alert-danger" v-if="updateerror">
                        {{this.updateerror}}
                    </div>
                    <div>
                        <label class="mb-1" for="email">Email:</label><br>
                        {{ user.email }}
                    </div>

                    <div class="mt-4">
                        <label class="mb-1" for="phone">Mobile Phone:</label><br>
                        {{ user.mobilenumber }}
                    </div>

                    <div class="mt-4">
                        <label class="mb-1">Address</label><br>
                        {{ user.address }}<br>
                        <template v-if="user.address2">{{ user.address2 }}<br></template>
                        {{ user.city }}, {{ user.state }} {{ user.zip }}<br>
                    </div>

                    <div>
                        <small class="text-danger" v-if="user.pendingAddressChange">
                            Recent Updates May Be Pending.<br>
                            *Only confirm if this reflects your recent change request.
                        </small>
                    </div>

                    <div class="mt-3">
                        <a :href="profileLink">Need to make updates?</a>
                    </div>

                    <div class="contact-details-modal-checkbox-container">
                        <input v-model="confirmed" id="contact-details-modal-checkbox-container-input" required  type="checkbox" class="mr-2">
                        <label class="form-check-label font-weight-normal" for="contact-details-modal-checkbox-container-input">
                            I confirm my information is accurate.
                        </label>
                    </div>
                    <div v-if="showValidError" class="has-error">
                       <div class="help-block">This checkbox is required.</div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="save()">Save and Confirm</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" @click="close()">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
    name: "ModalEmailPhone",
    props: [
        'user',
        'profileLink'
    ],
    data() {
        return {
            updateerror:false,
            confirmed: false,
            showValidError: false
        }
    },
    computed: {
        show() {
            return this.$store.state.user.showModalEmailPhone;
        }
    },
    methods: {
        ...mapActions('user', ['emailPhoneModalOff']),
        close() {
            this.emailPhoneModalOff();
        },
        save() {
            if (!this.confirmed) {
                this.showValidError = true;
                return;
            }

            this.$http.put(`/api/users`, {
                confirmed: this.confirmed
            }).then(function(response) {
                if (response.data.Status){
                    this.updateerror=false;
                    this.close();
                }else{
                    this.updateerror=response.data.Message;
                }
            }, (response) => {
                this._handleErrors(response.data, '#phone_email_info')
            });
        },
        _handleErrors: function(items, selector)
        {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="'+name+'"]')
                    el.closest('.form-group').addClass('has-error')
                    $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                }
            }
        }

    }
}
</script>

<style scoped>

</style>
